import isPlainObject from "lodash/isPlainObject";
import setWith from "lodash/setWith";

const FORBIDDEN = new Set(["__proto__", "prototype", "constructor"]);

function isSafeSegment(seg: string) {
  return seg.length > 0 && !FORBIDDEN.has(seg);
}

function isSafePath(path: string) {
  return path.split(".").every(isSafeSegment);
}

export function flatten(obj: object): Record<string, unknown> {
  const out: Record<string, unknown> = Object.create(null);

  function rec(prefix: string, val: unknown) {
    if (isPlainObject(val)) {
      for (const [k, v] of Object.entries(val as Record<string, unknown>)) {
        if (!isSafeSegment(k)) {
          throw new Error(
            `Unsafe key segment "${k}" under "${prefix || "<root>"}"`,
          );
        }
        rec(prefix ? `${prefix}.${k}` : k, v);
      }
    } else {
      out[prefix] = val;
    }
  }

  for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
    if (!isSafeSegment(k)) {
      throw new Error(`Unsafe root key segment "${k}"`);
    }
    rec(k, v);
  }

  return out;
}

export function expand(obj: Record<string, unknown>) {
  const out: Record<string, unknown> = Object.create(null);

  for (const [k, v] of Object.entries(obj)) {
    if (!isSafePath(k)) {
      throw new Error(`Unsafe key path "${k}"`);
    }
    setWith(out, k, v, () => Object.create(null));
  }

  return out;
}
